#!/usr/bin/env node

import { CLI } from "./cli.js"

const cli = new CLI()
cli.run()
